import API from '../libs/amplify.lib';
import { API_NAME } from '../constants';
import { generateProjectionExpressionV2, generateQueryParamsFromFilterV2WithTile } from '../utils/query.util';
import { parseResponse } from '../libs/response.lib';
import { clientAuthContext } from '../libs/auth.context';

/**
 *
 * @param {*} field - stage, taskName
 * @param {*} query - { conditions: [], operator: 'And/Or' }
 * @returns
 */
export const queryTilesData = async ({
  entity, accountId, query, field, operation = 'tile',
}) => API.post(API_NAME, `/${entity}?operation=${operation}`, {
  body: {
    accountId, field, query,
  },
})
  .then(parseResponse);

/**
 *
 * @param {*} search
 * @param {*} query - eg. { conditions: [], operator: 'And/Or' }
 * @param {*} projection - eg. { firstName: 1 }
 * @returns
 */
export const queryList = async ({
  accountId, lId, query, search, sort, searchKey, requestId, projection, skip, limit, entity, noDefault = false,
}) => API.post(API_NAME, `/${entity}?operation=list`, {
  body: {
    accountId,
    lId,
    query,
    search: (search || ''),
    sort,
    searchKey,
    projection: {
      ...(noDefault ? {} : projection)
    },
    skip,
    limit,
    requestId,
  },
  headers: {
    'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
  },
})
  .then(parseResponse);

export const getEntityDetails = async ({ _id, entity }) => API.get(API_NAME, `/${entity}?operation=detail&_id=${encodeURIComponent(_id)}`, {
  headers: {
    'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
  },
})
  .then(parseResponse);

export const gueryDistinctFields = async ({
  entity, accountId, field, search,
}) => API.post(API_NAME, `/${entity}?operation=getDistinctValues`, {
  body: { accountId, field, search },
  headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
})
  .then(parseResponse);

export const gueryDistinctFieldsV2 = async ({
  entity, lId, field,
}) => API.post(API_NAME, `/device?operation=getDistinctV2`, {
  body: { lId, field },
  headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
})
  .then(parseResponse);

export const exportData = async ({
  accountId, requestId, entity, columnConfig, filter, search, tile, skip = 0,
}) => {
  const params = generateQueryParamsFromFilterV2WithTile(filter, search, tile);
  const projection = generateProjectionExpressionV2(columnConfig);
  return API.post(API_NAME, `/${entity}?operation=export`, {
    body: {
      accountId,
      requestId,
      skip,
      projection,
      ...params,
    },
    headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
  })
    .then(parseResponse);
};

export const batchGetEntities = async ({
  accountId, _ids, requestId, projection, entity,
}) => API.post(API_NAME, `/${entity}?operation=batchGet`, {
  body: {
    accountId,
    _ids,
    projection,
    requestId,
  },
  headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
})
  .then(parseResponse);


export const exportDataV2 = async ({
  accountId, requestId, entity, columnConfig, filter, search, tile, skip = 0,
}) => {
  const params = generateQueryParamsFromFilterV2WithTile(filter, search, tile);
  const projection = generateProjectionExpressionV2(columnConfig);
  return API.post(API_NAME, `/${entity}?operation=export`, {
    body: {
      accountId,
      requestId,
      skip,
      projection,
      ...params,
    },
  })
    .then(parseResponse);
};

export const queryDeviceActivity = async ({
  accountId, xId, query, search, sort, requestId, projection, skip, limit, noDefault = false,
}) => API.post(API_NAME, `/device?operation=fetchDeviceActivity`, {
  body: {
    accountId,
    query,
    search: (search || ''),
    sort,
    xId,
    projection: {
      ...(noDefault ? {} : projection)
    },
    skip,
    limit,
    requestId,
  },
  headers: {
      'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
    },
})
  .then(parseResponse);

export const createProject = async ({ accountId, data }) => API.post(API_NAME, `/device?operation=createProject`, {
  body: {
    accountId, data
  },
})
  .then(parseResponse);

export const updateProject = async ({ accountId, lId, data }) => API.post(API_NAME, `/device?operation=updateProject`, {
  body: {
    accountId, lId, data
  },
  headers: {
    'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
  },
})
  .then(parseResponse);

export const updateRASP = async ({ accountId, lId, data }) => API.post(API_NAME, `/device?operation=updateRASP`, {
  body: {
    accountId, lId, data
  },
  headers: {
    'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
  },
})
  .then(parseResponse);

export const fetchReportV2 = async ({ accountId, lId, range }) => API.post(API_NAME, `/device?operation=fetchReportV2`, {
    body: {
      accountId, lId, range
    },
    headers: {
    'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
  },
  })
    .then(parseResponse);

export const fetchReport = async ({ accountId, lId, range }) => API.post(API_NAME, `/device?operation=fetchReport`, {
  body: {
    accountId, lId, range
  },
  headers: {
    'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
  },
})
  .then(parseResponse);

export const fetchSummaryAggrate = async ({ accountId, lId, range }) => API.post(API_NAME, `/device?operation=dashboardStatsFromSummaryAgg`, {
    body: {
      accountId, lId, range
    },
    headers: {
    'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
  },
  })
    .then(parseResponse);

export const fetchDeviceIPInsights = async ({ ipAddress, xId }) => API.post(API_NAME, `/device?operation=getIpaddressInsights`,
  {
    body: { ipAddress, xId },
    headers: {
    'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
  },
  },
)
    .then(parseResponse);

export const fetchDeviceIMeta = async ({ ipAddress }) => API.post(API_NAME, `/device?operation=getIpInfo`,
  {
    body: { ipAddress },
    headers: {
    'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
  },
  },
)
    .then(parseResponse);

export const fetchReportSandbox = async ({ accountId, lId, range }) => API.post(API_NAME, `/device?operation=fetchReport`, {
  body: {
    accountId, lId, range
  },
  headers: {
    'client-token': clientAuthContext.getToken(), // or any custom header like 'x-api-key': token
  },
})
  .then(parseResponse);
  
